// Still named for Adobe because Adobe is still what this ultimately delivers: it loads RCS's tag
// manager, whose `gazzetta` profile pulls in a Gazzetta/Adobe module among its twelve components.
// SPOR-2274 removed the Tealium layer that used to sit in between, not Adobe itself.
const TAG_MANAGER_SRC = 'https://components2.gazzettaobjects.it/rcs_tag-manager/v1/index.min.js';

// `defer` keeps the loader out of the parser's way while still guaranteeing it executes before
// DOMContentLoaded — which is what makes initialising from that event ordered rather than racy.
const INIT_TAG_MANAGER = `
document.addEventListener('DOMContentLoaded', function () {
  if (typeof RcsTagManager !== 'function') return;
  window.rcsTagManager = new RcsTagManager({ profileId: 'gazzetta' });
  window.rcsTagManager.load();
});
`;

export const AdobeAnalyticsHead = () => {
  return (
    <>
      <script crossOrigin="anonymous" defer src={TAG_MANAGER_SRC}></script>
      <script dangerouslySetInnerHTML={{ __html: INIT_TAG_MANAGER }}></script>
    </>
  );
};
